<template>
  <vs-card>
    <div slot="header">
      <h3>Outros Eventos do Beneficiário</h3>
    </div>

    <div v-if="!listOutrosEventos.length">
      <vs-alert>O beneficiário não possui outros eventos.</vs-alert>
    </div>

    <div v-else>
      <vs-collapse type="border">
        <vs-collapse-item
          v-for="(evento, index) in listOutrosEventos"
          :key="index"
        >
          <div slot="header">
            <vs-chip :color="evento.corStatus" class="mr-2">{{
              evento.nomeStatus ? evento.nomeStatus : 'Sem status'
            }}</vs-chip>
            <div>
              {{ evento.protocolo }} - {{ evento.placaChassi }} - Aberto em:
              {{ new Date(evento.dataAbertura).toLocaleDateString('pt-br') }} às
              {{
                new Date(evento.dataAbertura).toLocaleTimeString('pt-BR', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                })
              }}
            </div>
          </div>
          <div>
            <a :href="currentBaseUrl + evento.idEvento" target="_blank"
              >Link para acesso do evento</a
            >
          </div>
        </vs-collapse-item>
      </vs-collapse>

      <div v-if="totalQtdEventos > qtdMaxEventos" class="flex justify-end m-2">
        <vs-button v-if="!escondeBotao" @click="buscaTodosOutrosEventos"
          >Ver todos</vs-button
        >
      </div>

      <div class="mt-3">
        <p>Total por status:</p>
        <p>
          <span v-for="(status, index) in listQtdTiposEventos" :key="index">
            {{ status.nomeStatus }} ({{ status.quantidadeEventos }})
            <span v-if="index < listQtdTiposEventos.length - 1"> - </span>
          </span>
        </p>
      </div>
    </div>
  </vs-card>
</template>
<script>
export default {
  props: ['listOutrosEventos', 'listQtdTiposEventos', 'totalQtdEventos'],
  data() {
    return {
      currentBaseUrl: `${window.location.origin}/evento-analise/`,
      qtdMaxEventos: 5,
      escondeBotao: false,
    };
  },

  methods: {
    buscaTodosOutrosEventos() {
      this.$emit('buscaTodosOutrosEventos');
      this.escondeBotao = true;
    },
  },
};
</script>
